module.exports = __webpack_public_path__ + "static/media/skip-next-circle.b8ca9007.svg";